class gdlProductGroup extends HTMLElement {
  connectedCallback() {
    let anchors = Array.from(this.querySelectorAll('a'));
    anchors.forEach((anchor) => {
      anchor.addEventListener('click', this.handleAnchorClick);
    });
  }

  disconnectedCallback() {
    let anchors = Array.from(this.querySelectorAll('a'));
    anchors.forEach((anchor) => {
      anchor.removeEventListener('click', this.handleAnchorClick);
    });
  }

  handleAnchorClick = (e) => {
    // check data attr is-product-card
    if (e.target.dataset.isProductCard !== 'true') {
      return;
    }

    e.preventDefault();

    // create a fetch request to the anchor href and grab the html
    let url = e.target.href;
    url = `${url.split('?')[0]}?view=shop-the-look`;

    fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        // create a new div and set the innerHTML to the html
        const div = document.createElement('div');
        div.innerHTML = html;

        // get the closest gdl-shop-the-look-slide element
        const slide = e.target.closest('gdl-shop-the-look-slide');

        // replace the slide with the div innerHTML
        slide.innerHTML = div.innerHTML;
      });
  };
}

customElements.define('gdl-product-group', gdlProductGroup);
